enum EDisplayMode {
  LIST = 'list',
  BUTTON_GROUP = 'button-group',
}

type TRadioControlValue = string | number | boolean | undefined;

type TRadioControl = {
  value: TRadioControlValue;
  label: string;
};

export type { TRadioControl, TRadioControlValue };

export { EDisplayMode };
